import { parseLocalizedPathname } from './siteUrl.js'

/**
 * Build a locale-prefixed pathname for language switching.
 * @param {string} pathname - current location.pathname
 * @param {'en'|'pt'} language
 */
export function localizedPathname (pathname, language) {
  const { suffix } = parseLocalizedPathname(pathname)
  if (language === 'pt') {
    return suffix === '/' ? '/pt' : `/pt${suffix}`
  }
  return suffix === '/' ? '/en' : `/en${suffix}`
}

/**
 * Language implied by URL prefix, or null for x-default paths.
 * @param {string} pathname
 * @returns {'en'|'pt'|null}
 */
export function languageFromPathname (pathname) {
  const { lang } = parseLocalizedPathname(pathname)
  if (lang === 'pt' || lang === 'en') return lang
  return null
}
